export default __webpack_public_path__ + "static/media/21.cf4f5cc8.png";